import { makeStyles } from '@material-ui/core/styles';
import { replaceKeysLabelText } from '../../../../utils/utility';
import { pxToRem } from '../../../../styles/themes/vad/constants';
import { borderRadius } from '../../../../styles/themes/vad/borderRadius';

const useStyles = makeStyles(theme => {
  return {
    '@global': {
      '.sticky:not(.ghostdiv-reached)': {
        background: theme.palette.common.NearWhite2,
        border: `1px solid ${theme.mixins.White(300)}`,
        boxShadow: `0px 2px 4px 0px ${theme.mixins.Black(110)}`,
        '& .sticky-hidden': {
          display: 'none',
        },
        '& .section-container': {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          [theme.breakpoints.up('lg')]: {
            flexWrap: 'nowrap',
          },
        },
        '& .page-title': {
          paddingTop: theme.spacing(4),
          paddingBottom: theme.spacing(4),
          margin: 0,
          overflow: 'hidden',

          '& div': {
            maxWidth: '100%',
            '& h1': {
              textOverflow: 'ellipsis',
              maxWidth: '100%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            },
          },

        },
        '& .MuiTypography-h2': {
          ...theme.typography.h5Bold,
          margin: 0,
          paddingRight: pxToRem(20),
        },
        '& .detail-section': {
          display: 'flex',
          marginBottom: '0',
          width: 'auto',
          flexShrink: 0,
        },
        '& .cta-wrap': {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          justifyContent: 'space-between',
          [theme.breakpoints.up('sm')]: {
            justifyContent: 'left',
          }
        },
        '& .stickyFavoriteIcon': {
          [theme.breakpoints.up('lg')]: {
            ...theme.mixins.marginRight(pxToRem(20)),
          },
        },
      },
      '.mobile-sticky-bottom:not(.ghostdiv-reached)': {
        [theme.breakpoints.down('md')]: {
          background: '#FFF',
        },
      },
      '.sticky.ghostdiv-reached': {
        position: 'static',
        transform: 'none',
        transition: 'none',
      },
    },
    pageTitle: {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        marginBottom: theme.spacing(6),
      },
      '& .rating': {
        alignItems: 'center',
        verticalAlign: 'top',
        border: `1px solid ${theme.mixins.Grey(500)}`,
        borderRadius: borderRadius.b4Rem,
        ...theme.mixins.marginLeft(pxToRem(10)),
        ...theme.mixins.paddingLR(3, 3),
        [theme.breakpoints.up('lg')]: {
          padding: `${pxToRem(2)} ${pxToRem(5)}`,
          marginTop: theme.spacing(2),
          '.sticky:not(.ghostdiv-reached) &': {
            marginTop: theme.spacing(0),
          },
        },
        '& svg': {
          height: pxToRem(13),
          width: pxToRem(13),
          [theme.breakpoints.up('lg')]: {
            height: theme.spacing(2),
            width: theme.spacing(2),
          },
        },
        '& .MuiTypography-labelRegular': {
          ...theme.typography.body2Bold,
          margin: 0,
        },
      },
      '& h1': {
        ...theme.palette.common.ellipsis(2),
      }
    },
    location: {
      marginBottom: theme.spacing(3),
      color: theme.palette.text.tertiary,
      [theme.breakpoints.up('lg')]: {
        marginBottom: theme.spacing(2),
      },
    },
    detailSection: {
      display: 'none',
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: theme.spacing(5),
        '.sticky:not(.ghostdiv-reached) &:not(.btn-present) .contacts-section': {
          ...theme.mixins.paddingRight(0),
          ...theme.mixins.borderRight('none'),
        },
      },
    },
    ctaWrapper: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        '& .primaryCTA': {
          whiteSpace: 'nowrap',
        },
      },
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        alignItems: 'center',
      },
      '& .secondaryCTA .MuiButton-endIcon': {
        display: 'none',
      },
    },
    contacts: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      paddingBottom: theme.spacing(1),
      [theme.breakpoints.up('lg')]: {
        width: 'auto',
        flexDirection: 'row',
        alignItems: 'center',
        paddingBottom: theme.spacing(0),
      },
    },
    contactTxt: {
      color: props =>
        props.themeColor &&
        replaceKeysLabelText({ value: props.themeColor }, ['1']).value,
      textDecoration: 'none',
      paddingBottom: theme.spacing(3),
      [theme.breakpoints.up('lg')]: {
        display: 'inline',
        ...theme.mixins.marginRight(pxToRem(30)),
        paddingBottom: '0',
        '&:last-child': {
          ...theme.mixins.marginRight(0),
        },
        '&:hover': {
          color: theme.palette.primary.main,
          textDecoration: 'underline',
        },
      },
    },
    socialIcons: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.up('lg')]: {
        width: 'auto',
      },
      '& a': {
        ...theme.mixins.marginRight(theme.spacing(2)),
        '&:last-child': {
          ...theme.mixins.marginRight(0),
        },
      },
      '& .MuiIconButton-root': {
        padding: theme.spacing(1),
        backgroundColor: theme.mixins.Grey(100),
        height: theme.spacing(5),
        width: theme.spacing(5),
        '&:hover': {
          backgroundColor: props =>
            props.themeColor &&
            replaceKeysLabelText({ value: props.themeColor }, ['1']).value,
          '& svg': {
            color: theme.palette.primary.contrastText,
          },
        },
        '&.facebookIcon svg': {
          height: pxToRem(20),
          width: pxToRem(20),
        },
        '& svg': {
          color: theme.palette.primary.main,
        },
      },
    },
    verticalBar: {
      width: '2px',
      height: '24px',
      border: `1px solid ${theme.palette.common.DisabledGrey}`,
      ...theme.mixins.marginLeft(12),
      ...theme.mixins.marginRight(30),
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    ml30: {
      ...theme.mixins.marginLeft(pxToRem(30)),
    },
    dflex: {
      display: 'flex'
    },
    vdiv: {
      [theme.breakpoints.down('md')]: {
        ...theme.mixins.borderRight(`1px solid ${theme.palette.common.DisabledGrey}`),
        ...theme.mixins.marginRight(pxToRem(13.5)),
        height: '40px'
      },
    },
    modalPopUp: {
      backgroundColor: theme.mixins.White(),
      '& .MuiDialog-scrollPaper': {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      },
      '& .MuiPaper-root': {
        margin: '0',
        height: '100%',
        width: '100%',
        '& > button': {
          padding: 0,
          '& svg': {
            color: theme.mixins.Black(),
            width: theme.spacing(3),
            height: theme.spacing(3),
          },
        },
      },
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
      '& .MuiDialogTitle-root': {
        padding: 0,
      },
      '& .MuiDialogContent-root': {
        margin: `${theme.spacing(8)} ${theme.spacing(3)} 0`,
        padding: 0,
        color: theme.mixins.Black(),
        '& .MuiTypography-h2': {
          ...theme.mixins.marginLeft(0),
        },
        '& button': {
          position: 'absolute',
          bottom: theme.spacing(6),
          ...theme.mixins.left(theme.spacing(0)),
        },
      },
      '& .detail-section': {
        display: 'flex',
        flexDirection: 'column',
      },
      '& .mobile-cta-wrap': {
        display: 'flex',
        position: 'absolute',
        bottom: '0',
      },
    },
  };
});

export default useStyles;
